export { default } from "./DistributionLevelFactorScore";
